import {
  BorderStyle,
  ColorThemeType,
  CSSProperties
} from '@com-delta-idp/mnx-ui-kit';
import { Currency, Pricing } from './ui.interfaces';

export interface CreditSummary {
  currency?: Currency;
  statementCredit: string;
  statementCreditLabel: string;
  total: Pricing;
  totalLabel: string;
}

export interface CreditSummaryStyles {
  backgroundColor: string;
  border?: BorderStyle;
  colorTheme?: ColorThemeType;
  decimalPointsUi: CSSProperties;
  statementCreditUi: CSSProperties;
  statementCreditLabel: CSSProperties;
  total: CSSProperties;
  totalLabel: CSSProperties;
}
